import * as React from "react";

const SvgInsertChart = ({ color, size }) => (
  <svg
    viewBox="0 0 24 25"
    width={`${24 * (size || 1)}px`}
    height={`${24 * (size || 1)}px`}
    fill={color}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      opacity={0.3}
      d="M19 5.5H5v14h14v-14zm-10 12H7v-7h2v7zm4 0h-2v-10h2v10zm4 0h-2v-4h2v4z"
      fill={color}
    />
    <path
      d="M3 5.5v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2zm2 0h14v14H5v-14zm2 5h2v7H7v-7zm4-3h2v10h-2v-10zm4 6h2v4h-2v-4z"
      fill={color}
    />
  </svg>
);

export default SvgInsertChart;
